/**
 * Utility functions for plant disease analysis
 */

/**
 * Ensures a value is always an array
 * @param {*} value - The value to convert to array
 * @returns {Array} - An array of values
 */
export const ensureArray = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value].filter(Boolean);
};

/**
 * Initial state for analysis results
 */
export const INITIAL_ANALYSIS_STATE = {
  diseaseName: "",
  description: "",
  plantName: "",
  diseaseSeverity: "",
  recommendations: [],
  nextSteps: [],
  nutritionalDeficiencies: [],
  symptoms: [],
  confidenceLevel: "",
};

/**
 * Extracts analysis data from API response
 * @param {Object} results - The API response data
 * @returns {Object} - Extracted and formatted analysis data
 */
export const extractAnalysisData = (results) => {
  if (!results || Object.keys(results).length === 0) {
    return null;
  }

  return {
    diseaseName: results.disease_detected || "",
    description: results.detailed_analysis || results.info || "",
    plantName: results.plant_name || "",
    diseaseSeverity: results.disease_severity || "N/A",
    recommendations: ensureArray(results.recommendations),
    nextSteps: ensureArray(results.next_steps),
    symptoms: ensureArray(results.symptoms),
    nutritionalDeficiencies: ensureArray(results.nutritional_deficiencies),
    confidenceLevel: results.confidence_level || "",
  };
};

/**
 * Updates state variables using setState functions
 * @param {Object} data - The data to set
 * @param {Function} setterFunction - The setter function for each key
 */
export const updateStateWithData = (data, setterFunctions) => {
  if (!data) return;

  Object.entries(data).forEach(([key, value]) => {
    if (setterFunctions[key]) {
      setterFunctions[key](value);
    }
  });
};
